<div class="beats-not-found">
  <div class="btv-icon-info-big"></div>
  <h3 class="common-section-title--notFoundMessage">{{ title }}</h3>
  <a class="common-section-title--link" routerLink="/catalog" (click)="clickHandler()"> Go to catalog </a>
</div>
